import { hasPermission, PermissionKey, type PermissionMap, PermissionScope } from "@fitness-app/data-models";

/**
 * Czy aktor widzi CAŁY katalog planów treningowych / jadłospisów, łącznie
 * z cudzymi i nieudostępnionymi, czy tylko swoje plus te oznaczone `shared`.
 *
 * Do TRE-1855 obie listy pytały o `role !== UserRole.TRAINER`, więc pełny wgląd
 * miał wyłącznie właściciel konta. Panel tymczasem oferował administracji
 * z zakresem ALL edycję i przełącznik udostępnienia — na wierszach, których
 * nie dostawała w wynikach. Zakres ALL to właśnie „zarządzam katalogiem całego
 * konta", więc to on decyduje.
 *
 * Uwaga: to NIE znosi sensu flagi `shared`. Poniżej ALL nadal obowiązuje
 * „moje + udostępnione", więc prywatny plan jednej trenerki nie wycieka do
 * drugiej.
 */
const seesWholeCatalog = (
  permissions: PermissionMap,
  key: typeof PermissionKey.PROGRAMS_MANAGE | typeof PermissionKey.NUTRITION_MANAGE,
): boolean => hasPermission(permissions, key, PermissionScope.ALL);

export const seesWholeTrainingCatalog = (permissions: PermissionMap): boolean =>
  seesWholeCatalog(permissions, PermissionKey.PROGRAMS_MANAGE);

export const seesWholeNutritionCatalog = (permissions: PermissionMap): boolean =>
  seesWholeCatalog(permissions, PermissionKey.NUTRITION_MANAGE);
